import styled, { css } from 'styled-components';

export const AiAlertsCtaWrapper = styled.div`
  ${({ theme, $isInsideChat }) => css`
    align-items: center;
    border-radius: 12px;
    border: 1px solid ${theme.v2.colors.neutral.highMedium};
    cursor: pointer;
    display: flex;
    flex-direction: row;
    gap: 8px;
    padding: 8px 16px;
    background: transparent;
    margin-bottom: ${$isInsideChat ? '12px' : 0};
    height: 40px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      padding: 8px 12px;
    }
  `}
`;

export const SeverityDot = styled.span`
  ${({ $severity, theme }) => {
    const colors = {
      critical: {
        bgColor: theme.v2.colors.feedback.problemPure,
        shadow: `drop-shadow(0 0 5px ${theme.v2.colors.feedback.problemPure});`,
      },
      warning: {
        bgColor: theme.v2.colors.feedback.attentionPure,
        shadow: `drop-shadow(0 0 5px ${theme.v2.colors.feedback.attentionPure});`,
      },
    };

    return css`
    min-width: 16px;
    min-height: 16px;
    border-radius: 100%;
    background-color: ${colors[$severity].bgColor};
    filter: ${colors[$severity].shadow};
  `;
  }}
`;

export const Label = styled.span`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    color: ${theme.v2.colors.neutral.lowDark};

    strong {
      font-weight: ${theme.v2.font.weights.bold};
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;

export const ResolveCta = styled.span`
  ${({ theme, $dark }) => css`
    align-items: center;
    color: ${theme.v2.colors.neutral[$dark ? 'lowDark' : 'lowMedium']};
    display: flex;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    justify-content: center;
    button {
      transform: rotate(90deg);
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;
